import Client from '../../../utils/ClientVOIM';
import URL from '../../../utils/URL';
import { myLog } from '../../../utils/Utility';

// Flag Category List
export function flagSessionCategory(callBack) {
    return function () {
        Client.get(URL.IM_EDUCATOR.GET_FLAGSESSION, {}, true)
            .then((response) => {
                myLog('====flagSessionCall response===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====flagSessionCall error===????', error);
                callBack(false);
            });
    };
}

// Flag Submit PUT method
export const submitFlagSession = (values, callBack) => {
    return function () {
        Client.put(URL.IM_EDUCATOR.PUT_FLAGSESSION, values, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};
